<script setup>

defineProps({
    error: String
})
</script>

<template>
    <!-- red-2, not accent-red: validation text sits on white, where accent-red is
         3.38:1 — below the AA 4.5:1 this size of text needs. red-2 is 6.05:1. -->
    <p v-if="error" class="mt-5 text-red-2 font-semibold">{{ error }}</p>
</template>
